import { render } from "./CompetenciesView.vue?vue&type=template&id=03e55f04&scoped=true"
import script from "./CompetenciesView.vue?vue&type=script&lang=js"
export * from "./CompetenciesView.vue?vue&type=script&lang=js"

import "./CompetenciesView.vue?vue&type=style&index=0&id=03e55f04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e55f04"]])

export default __exports__